<template>
<main-content v-if="$can('manage', 'gateway')">
    <manage-payman></manage-payman>
</main-content>
<main-content v-else-if="is_authenticated">
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-actions :style="headerAction">
                <router-link to="/payman/create" class="btn btn-success">{{ $t('payman.btn.add') }}</router-link>
            </kt-panel-header-actions>
        </kt-panel-header>
    </kt-panel>
    <own-payman></own-payman>
</main-content>
<main-content v-else-if="is_authenticated_pending">
    <kt-panel>
        <kt-panel-body>
            <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                {{ $t('message.authenticated_pending_stil') }}
            </p>
        </kt-panel-body>
    </kt-panel>
</main-content>
<main-content v-else>
    <kt-panel>
        <kt-panel-body>
            <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                {{ $t('message.not_authenticated_stil') }}
                <router-link v-if="profile_completed" 
                    class="btn btn-brand d-block w-25 text-center align-content-center mx-auto mt-3" 
                    to="/profile/authenticate"> {{ $t('complete_authentication') }}</router-link>
                <router-link v-else 
                    class="btn btn-brand d-block w-25 text-center align-content-center mx-auto mt-3" 
                    to="/profile/update"> {{ $t('complete_info') }}</router-link>
            </p>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import ManagePayman from './components/manage-payman'
import OwnPayman from './components/own-payman'

export default {
    components: {
        'main-content': mainContent,
        'own-payman': OwnPayman,
        'manage-payman': ManagePayman,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },

    computed: {
        ...mapGetters('user', [
            'is_authenticated', 'is_authenticated_pending', 'profile_completed'
        ]),
    },
    mounted() {
    }
}
</script>

<style>

</style>